export default __webpack_public_path__ + "static/volunteer-banner-81455bcfdf8fd014f968a41cb004c8a5.jpg";